// extracted by mini-css-extract-plugin
module.exports = {"appWrapper":"dePcSW8g"};